import 'vant/es/toast/style';
export default {
  data() {
    return {
      lang: 'hk',
      userTerms: [{
        type: 'title',
        hkText: "條款與細則"
      }, {
        type: 'content',
        hkText: '歡迎來訪本網站！本網站的宗旨為提供育兒、升學、出版、各項優惠及服務信息等，務求與家長建立長久而貼心的服務及友好關係。為了保障此網站能夠被合法及適當使用，本網站訂立以下使用條款。任何人士瀏覽此網站"用家"（Users）都同意遵守此條款。'
      }, {
        type: 'subT',
        hkText: "定義",
        enText: "Definitions"
      }, {
        type: 'content',
        hkText: "在此條款中，以下的定義會被應用："
      }, {
        type: 'content',
        hkText: '1. "內容" 指所有可以從網址取得的內容包括資訊、數據、內容、圖表、字體、形象、相片、商號、按徽圖鈕（button icons）、聲音、音樂、錄影及軟件；'
      }, {
        type: 'content',
        hkText: '2. "知識產權" 指有關內容的所有形式的知識產權包括版權、註冊設計、商標及發明權；'
      }, {
        type: 'content',
        hkText: '3. "連結網站" 指與網站連結的網站〔包括但不限於超文本連結（hypertext links）、內容連結（content links）及邊框連結（frame links）〕；'
      }, {
        type: 'content',
        hkText: '4. "網站" 本網站但不包括連結網站；'
      }, {
        type: 'content',
        hkText: '5. "供應者" 指供應內容網站的人；及'
      }, {
        type: 'content',
        hkText: '6. "用家" 指以任何目的瀏覽網站的人。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '否認責任聲明'
      }, {
        type: 'content',
        hkText: '用家同意承擔使用網站的風險，網站是由本網站以"現狀"（"as is" basis）提供。本網站未曾就網站的運作及其內容作出任何聲明或隱含的聲稱或許諾。按香港法律"管制否認責任條款"法令所容許的極限，本網站否認所有表明或隱含的許諾，包括但不限於有關商售品質及對某特定用途的適用性。本網站不會承擔任何使用網站所引致的賠償責任，包括但不限於直接、間接、連帶、懲罰性和跟隨引起的損失。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '第三者內容'
      }, {
        type: 'content',
        hkText: '本網站是第三者所供應的內容的分送者，而不是該等內容的出版者。本網站沒有編輯該等內容的權利。 由任何供應者（本網站除外）或用家所提供的內容中所包含的意見、建議、聲明、服務、提出及其他資訊，均為該等供應者或用家所提供及承擔責任，本網站或其行政人員、董事及職員不用承擔任何責任。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '網上行為'
      }, {
        type: 'content',
        hkText: '用家同意只使用本網站作合法用途。用家被嚴禁在本網站上出示或傳送任何非法、有傷害性、威嚇、辱罵、滋擾、中傷、下流、淫穢、有關性方面明顯表露、歧視或其他令人反感的資料，包括但不限於煽動任何刑事行為、產生民事責任或違反任何地區、州、國家及國際法律的行為。如本網站收到有關用家所提供的內容中有侵權、中傷、具破壞性、非法或令人反感的投訴，本網站在調查有關投訴後，有絕對權力決定是否刪除有關內容或提出刪除要求。本網站有權披露任何內容或其他電子資訊傳遞（i）來滿足任何法律、法規或政府要求；（ii）如果作出該項披露是可以令本網站所運作必須或合適的行為或（iii）來保障本網站用家及供應者的權益或財產。本網站保留權力禁止任何它認為對用家、本網站社群、本網站權益及第三者權益產生有傷害及違法的行為、資訊或內容。雖然 本網站保留該等權力，但不能保證可以即時刪除問題內容。所以，本網站、其有關人士、其行政人員、董事、職員或代理均不會就針對供應者（本網站除外）或用家在網上的行為、資訊傳遞或提供的內容所採取的行動或不採取行動方面負上任何責任。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '終止使用'
      }, {
        type: 'content',
        hkText: '如本網站本身相信用家的行為已觸犯任何法律或對其他用家、第三者供應者、服務供應者或本網站不利，本網站有權在未事先通知情況下終止用家連線到網站或暫停用家連線到網站。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '適用法律'
      }, {
        type: 'content',
        hkText: '此條款由香港法律管轄。用家在不可撤銷及無條款的情況下同意接受香港法院為唯一司法區域。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '分割'
      }, {
        type: 'content',
        hkText: '此條款的各點是可以被分割的。如因任何理由某點的全部或部份是無效或不能行使，該無效或不能行使的部份則會被視為無效處理，但不影響其餘條款的有效性及行使性。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '全部協議'
      }, {
        type: 'content',
        hkText: '此條款及所有此條款提及的文件，顯示出用家及 本網站就彼此關係的全部了解，更代替先前任何聲稱或聲明，此條款可能間斷性被修改。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '知識產權'
      }, {
        type: 'content',
        hkText: '本網站內容受到知識產權保護。有關內容的編輯（包括內容的搜集、安排及組合）是本網站的獨有產權，受到香港法律的版權法令及國際版權法規保護。用戶有權下載部份內容作為網上訂購貨物或服務之用。其他用途包括複製、修改、分送、傳送、顯示或作表演用途均嚴格禁止，如法例許可除外。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '私隱保障'
      }, {
        type: 'content',
        hkText: '客戶的私隱保障是本網站優先考慮的問題。'
      }, {
        type: 'content',
        hkText: '本網站設置獨立及保密的伺服器來貯存個人資料。此伺服器不會連接任何網站。本網站更不會將客戶資料出售、租出或作任何交易。本網站可能提供有關客戶、營業額、使用密度及其他網上資料的統計數字，但此等統計不會存有任何辨認個人身分的資料。'
      }]
    };
  },
  components: {},
  methods: {}
};